import { useQuery } from '@apollo/client';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import useGraphQLErrorBoundary from 'src/hooks/useGraphQLErrorBoundary';
import { PRACTITIONERS_AVAILABILITIES_QUERY } from '../queries/practitionersAvailabilities';
const usePractitionersAvailabilities = ({
  clinicReferenceId,
  treatmentBundleReferenceId,
  locationReferenceId,
  onCompleted
}) => {
  const personReferenceId = usePersonId();
  const {
    data,
    ...rest
  } = useQuery(PRACTITIONERS_AVAILABILITIES_QUERY, {
    variables: {
      clinicReferenceId,
      treatmentBundleReferenceId,
      personReferenceId,
      locationReferenceId
    },
    skip: !clinicReferenceId || !treatmentBundleReferenceId || !personReferenceId,
    onCompleted
  });
  useGraphQLErrorBoundary(rest.error);
  return {
    data: data?.practitionersAvailabilities || [],
    ...rest
  };
};
export default usePractitionersAvailabilities;